import { render } from "./ModalContentComponent.vue?vue&type=template&id=229350d1"
import script from "./ModalContentComponent.vue?vue&type=script&lang=js"
export * from "./ModalContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ModalContentComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "229350d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('229350d1', __exports__)) {
    console.log('reload')
    api.reload('229350d1', __exports__)
  }
  
  module.hot.accept("./ModalContentComponent.vue?vue&type=template&id=229350d1", () => {
    console.log('re-render')
    api.rerender('229350d1', render)
  })

}


export default __exports__